/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Bell_Object_ClaimInputs */

const en_bell_object_claim = /** @type {(inputs: Bell_Object_ClaimInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Claim on ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Claim on {reference}" |
*
* @param {Bell_Object_ClaimInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_object_claim = /** @type {((inputs: Bell_Object_ClaimInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Object_ClaimInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_object_claim(inputs)
});